import * as React from "react";
import { connect, ConnectedProps } from "react-redux";

import SelectedCheckmark from "components/icons/SelectedCheckmark";
import style from "components/products/getting-started.scss";
import { StoreState } from "store";

interface Props {
    successText: string;
    testId: string;
    dataType: string;
}

const mapState = (state: StoreState) => ({
    theme: state.themeReducer.theme,
    user: state.userReducer.user,
});

const connector = connect(mapState);

const StepCompletedText = (props: Props & ConnectedProps<typeof connector>): JSX.Element => {
    return (
        <>
            <div data-testid={props.testId} data-type={props.dataType} className={style.templateSelectedBlock}>
                <SelectedCheckmark color={props.theme.accordianSuccessTextColor}></SelectedCheckmark>
                <div className={style.templateSelected}>{props.successText}</div>
            </div>
        </>
    );
};

export default connector(StepCompletedText);
